<style lang="less" scoped>
@media screen and (max-width: 500px) {
  .header {
    width: 100%;
    display: flex;
    background: #0e5b10;
    padding: 5px 10px;
    box-sizing: border-box;
    .logo {
      width: 180px;
      vertical-align: middle;
    }
    h2 {
      color: #fff;
      font-size: 16px;
      font-weight: normal;
      padding-top: 25px;
      margin-left: 5px;
    }
  }
}
@media screen and (min-width: 500px) {
  .header {
    //  background: url("../assets/image/zxm.png");
    background-blend-mode: multiply;
    // background-color: rgba(12, 12, 12, 0.5);
    padding: 10px 100px;
    box-sizing: border-box;
    .logo {
      width: 250px;
    }
  }
}
</style>
<template>
  <div class="header">
    <img class="logo" src="@/assets/image/logo.jpg" />
    <!-- <h2>华南植物园</h2> -->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>